import { useState, useEffect } from 'react'

export const useCurrentOrigin = () => {
  const [origin, setOrigin] = useState<string>('')

  useEffect(() => {
    setOrigin(window.location.origin)
  }, [])

  return origin
}
